import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';
import { LandingPage } from './pages/public/LandingPage.tsx';
import { PublicReportPage } from './pages/public/PublicReportPage.tsx';
import { CookieBanner } from './components/CookieBanner.tsx';

// The dashboard (Clerk, charts) and the replay player load only where they are used.
const Dashboard = lazy(() => import('./Dashboard.tsx'));
const Admin = lazy(() => import('./pages/admin/AdminApp.tsx'));
const TermsPage = lazy(() => import('./pages/public/legal/TermsPage.tsx').then((m) => ({ default: m.TermsPage })));
const PrivacyPage = lazy(() => import('./pages/public/legal/PrivacyPage.tsx').then((m) => ({ default: m.PrivacyPage })));
const CookiesPage = lazy(() => import('./pages/public/legal/CookiesPage.tsx').then((m) => ({ default: m.CookiesPage })));
const DpaPage = lazy(() => import('./pages/public/legal/DpaPage.tsx').then((m) => ({ default: m.DpaPage })));
const SubprocessorsPage = lazy(() => import('./pages/public/legal/SubprocessorsPage.tsx').then((m) => ({ default: m.SubprocessorsPage })));
const RealVisitorsPage = lazy(() => import('./pages/public/RealVisitorsPage.tsx').then((m) => ({ default: m.RealVisitorsPage })));
const DocsPage = lazy(() => import('./pages/public/DocsPage.tsx').then((m) => ({ default: m.DocsPage })));
const PublicVisitPage = lazy(() => import('./pages/public/PublicVisitPage.tsx').then((m) => ({ default: m.PublicVisitPage })));

function Loading() {
  return <p className="muted pad">Loading…</p>;
}

/** Public pages (no sign-in to read them) at `/`, `/real-visitors`, `/r/*` and the legal pages, the admin area at `/admin`; everything else is the signed-in dashboard. */
export function Root() {
  return (
    <Suspense fallback={<Loading />}>
      <CookieBanner />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/real-visitors" element={<RealVisitorsPage />} />
        <Route path="/r/:slug" element={<PublicReportPage />} />
        <Route path="/r/:slug/v/:index" element={<PublicVisitPage />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="/docs/:slug" element={<DocsPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/cookies" element={<CookiesPage />} />
        <Route path="/dpa" element={<DpaPage />} />
        <Route path="/subprocessors" element={<SubprocessorsPage />} />
        <Route path="/admin/*" element={<Admin />} />
        <Route path="*" element={<Dashboard />} />
      </Routes>
    </Suspense>
  );
}
